import script from "./WatercolorCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./WatercolorCanvas.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__